import { useContext } from 'react'

import { TextInput } from '~/components/TextInput'
import { studentEvaluationDemoContext } from '~/pages/authenticated/personalTrainer/studentEvaluationDemo'

type Props = {
  field:
    | 'abdominal'
    | 'medialThigh'
    | 'suprailiac'
    | 'chest'
    | 'triceptal'
    | 'axilla'
    | 'subscapular'
}

export const Mean: React.FC<Props> = ({ field }) => {
  const { data } = useContext(studentEvaluationDemoContext)

  return (
    <TextInput
      readOnly
      value={(
        (data?.[field].reduce((p, c) => p + c, 0) || 0) /
        (data?.[field].length ?? -1)
      ).toFixed(2)}
    />
  )
}
